'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactJss = require('react-jss');

var _reactJss2 = _interopRequireDefault(_reactJss);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Grid(_ref) {
  var _cn;

  var classes = _ref.classes,
      fluid = _ref.fluid,
      classNameCustom = _ref.className,
      style = _ref.style,
      children = _ref.children,
      ComponentClass = _ref.componentClass,
      noPadding = _ref.noPadding;

  var className = (0, _classnames2.default)((_cn = {}, _defineProperty(_cn, classes.grid, !fluid), _defineProperty(_cn, classes.gridFluid, fluid), _defineProperty(_cn, classes.noPadding, noPadding), _cn), classNameCustom);

  return _react2.default.createElement(
    ComponentClass,
    { className: className, style: style },
    children
  );
}

Grid.propTypes = {
  classes: _propTypes2.default.object,
  fluid: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  children: _propTypes2.default.node,
  componentClass: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),
  noPadding: _propTypes2.default.bool
};

Grid.defaultProps = {
  componentClass: 'div'
};

exports.default = (0, _reactJss2.default)(_styles2.default)(Grid);


//////////////////
// WEBPACK FOOTER
// ../dist/grid/index.js
// module id = 123
// module chunks = 0